<template>
	<div class="measuresContainer">
		<proposed-draft
			:proposed-draft="proposedDraft"
			:srv-phase-id="phaseId"
			:srv-actor-properties-goal="srvActorPropertiesGoal"
			:current-actor-id="currentActorId"
		></proposed-draft>
		<!-- @vue-expect-error -->
		<measure-node
			v-for="measure in measures"
			v-bind:key="measure.id"
			:srv-phase-id="phaseId"
			:is-selectable="true"
			:measure="measure"
			:draft-creatable="currentActorCanCreateDrafts && !(measure.enacted_by_actors & [pp.currentActorId, VueStore.getters.actorData(pp.currentActorId).principalGroupId]).length"
		></measure-node>
	</div>
</template>

<script>
// Other components
import { i18n } from "../utils";
import MeasureNode from "./measure_node.vue";
import ProposedDraft from "./proposed_draft.vue";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: {
		srvPhaseId: Number,
		srvMeasures: Array,
		srvProposedDraft: Object,
		srvActorPropertiesGoal: Object,
		srvCurrentActorId: Number,
		currentActorCanCreateDrafts: Boolean,
	},
	components: {
		"measure-node": MeasureNode,
		"proposed-draft": ProposedDraft,
	},
	data: function () {
		return {
			measures: window._.sortBy(
				this.srvMeasures,
				(m) => m.enacted_by_actors.length,
			),
			proposedDraft: this.srvProposedDraft,
			currentActorId: this.srvCurrentActorId,
		};
	},
	computed: {
		draftDecided: function () {
			return (
				this.proposedDraft &&
				(this.proposedDraft["passed?"] || this.proposedDraft["failed?"])
			);
		},
		phaseId: function () {
			return this.srvPhaseId !== undefined
				? this.srvPhaseId
				: pp.gameState.phaseId;
		},
	},
	mounted() {
		pp.vue.bus.$on("draft-CLOSE", (draft) => {
			// @ts-expect-error
			this.proposedDraft = null;
			this.clearProposedDraft();
		});
		pp.vue.bus.$on("draft-CREATE", (draft) => {
			this.handleIncomingDraft(draft);
		});
		pp.vue.bus.$on("draft-UPDATE", (draft) => {
			this.handleIncomingDraft(draft);
		});
		pp.vue.bus.$on("rating-CREATE", this.handleIncomingRating);
		pp.vue.bus.$on("measures-CHANGE", this.handleChangedMeasures);
		if (this.proposedDraft && this.draftDecided) {
			this.previewMeasure(null);
		}
	},
	beforeDestroy() {
		pp.vue.bus.$off("draft-CLOSED");
		pp.vue.bus.$off("draft-CREATE");
		pp.vue.bus.$off("rating-CREATE", this.handleIncomingRating);
		pp.vue.bus.$off("measures-CHANGED");
	},
	methods: {
		clearProposedDraft() {
			// @ts-expect-error
			this.proposedDraft = null;
		},
		handleIncomingDraft(draft) {
			// pp.log("incoming draft decided?", this.draftDecided, draft);
			draft.voting_finished = draft["passed?"] || draft["failed?"];
			draft.ratings =
				this.proposedDraft == undefined || this.proposedDraft == null
					? []
					: // @ts-expect-error
						this.proposedDraft.ratings;
			this.proposedDraft = draft;
			VueStore.commit("clearPreviewFor", pp.currentActorId);
			this.previewMeasure(null);
			if (this.draftDecided || draft.ratings.length > draft.required_votes) {
				this.previewMeasure(null);
			}
		},
		handleIncomingRating(incomingRating) {
			// @ts-expect-error
			let newRatings = this.proposedDraft.ratings || [];
			newRatings = newRatings.concat([incomingRating]);
			// @ts-expect-error
			this.proposedDraft.ratings = newRatings;
		},
		handleChangedMeasures(measures) {
			// pp.log("handling measures:", measures);

			measures.map((incomingMeasure) => {
				const idxOfPresentMeasure = window._.findIndex(
					this.measures,
					(m) => m.id == incomingMeasure.id,
				);
				if (idxOfPresentMeasure == -1) {
					incomingMeasure.is_new = true;
					this.measures.push(incomingMeasure);
				} else {
					this.measures[idxOfPresentMeasure] = incomingMeasure;
				}
			});
			this.measures = window._.sortBy(
				this.measures,
				(m) => m.enacted_by_actors.length,
			);
		},
		previewMeasure(measure) {
			VueStore.commit("updatePreviewingMeasure", {
				measure: measure,
			});
		},
	},
};
</script>
